<div [ngClass]="['signin-overlay', visibleSigninModal ? 'show' : '']">
    <ng-container *ngIf="!showLearnMore; else learnMore">
        <div [ngClass]="['signin-password-container']">
            <div>
                <mat-icon
                    data-cy="login-input-window-x-icon"
                    svgIcon="cancel-close"
                    style="cursor: pointer; color: white"
                    (click)="closeOverlay()"
                ></mat-icon>
            </div>

            <div class="title-container">
                <div
                    data-cy="login-input-window-title"
                    class="title-large bold"
                >
                    {{ "dlg.signin.title" | translate }}
                </div>
                <div
                    data-cy="login-input-window-info-text"
                    class="text-small light"
                >
                    {{ "dlg.signin.learn" | translate }}
                    <span
                        data-cy="login-input-window-learn-more-button"
                        class="text-small bold"
                        style="cursor: pointer"
                        (click)="onShowLearnMore()"
                        >{{ "dlg.signin.learnmore.title" | translate }}</span
                    >
                </div>
            </div>
            <div class="input-container">
                <div
                    data-cy="login-input-role-title"
                    class="role-title text-large light"
                >
                    {{ selecteRole?.role }}
                </div>
                <div
                    data-cy="login-input-window-secondary-text"
                    class="text light"
                >
                    {{ "dlg.signin.another" | translate }}
                    <span
                        data-cy="login-input-window-go-back-button"
                        class="text bold"
                        (click)="onGoBackClick()"
                        style="cursor: pointer"
                        *ngIf="!isSwitchAccounts"
                        >{{ "dlg.signin.back" | translate }}</span
                    >
                    <span
                    data-cy="login-input-window-exit-screen-button"
                        class="text bold"
                        (click)="onExitClick()"
                        style="cursor: pointer"
                        *ngIf="isSwitchAccounts"
                        >{{ "dlg.signin.exit" | translate }}</span
                    >
                </div>
                <div [ngClass]="['icon-input', signInErrorMsg ? 'error' : '']">
                    <input
                        data-cy="login-input-window-password-field"
                        class="text-large light"
                        placeholder="Password"
                        [type]="showPassword() ? 'text' : 'password'"
                        [(ngModel)]="passwordValue"
                        (ngModelChange)="onPasswordChange()"
                    />
                    <div *ngIf="!passwordVisible">
                        <mat-icon
                            data-cy="login-input-window-password-reveal-button"
                            svgIcon="password-hide"
                            style="cursor: pointer"
                            *ngIf="isIconLoaded('password-hide')"
                            (click)="onPasswordVisible()"
                        ></mat-icon>
                        <mat-progress-spinner
                            diameter="20"
                            value="100"
                            mode="indeterminate"
                            *ngIf="!isIconLoaded('password-hide')"
                        ></mat-progress-spinner>
                    </div>
                    <div *ngIf="passwordVisible">
                        <mat-icon
                            data-cy="login-input-window-password-hide-button"
                            svgIcon="password-watch"
                            style="cursor: pointer"
                            *ngIf="isIconLoaded('password-watch')"
                            (click)="onPasswordVisible()"
                        ></mat-icon>
                        <mat-progress-spinner
                            diameter="20"
                            value="100"
                            mode="indeterminate"
                            *ngIf="!isIconLoaded('password-watch')"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <p
                    data-cy="login-input-window-password-warning"
                    class="error-msg text light"
                    *ngIf="signInErrorMsg"
                >
                    {{ signInErrorMsg }}
                </p>
            </div>
            <button
                data-cy="login-input-window-login-button"
                class="signin-btn caption"
                (click)="onSigninClick()"
                [disabled]="btnDisable || signInErrorMsg"
            >
                {{ "dlg.signin.title" | translate }}
            </button>
            <div
                data-cy="login-input-window-forgot-password-button"
                class="caption forgot-password"
            >
                {{ "dlg.signin.password.forgot" | translate }}
            </div>
        </div>
    </ng-container>
    <ng-template #learnMore>
        <div class="signin-password-container learn-more">
            <div class="learn-more-contents">
                <div>
                    <mat-icon
                        data-cy="login-input-learn-more-window-x-icon"
                        svgIcon="cancel-close"
                        style="cursor: pointer; color: white"
                        (click)="closeOverlay()"
                    ></mat-icon>
                </div>
                <div
                    data-cy="login-input-learn-more-title"
                    class="subtitle bold"
                >
                    {{ "dlg.signin.learnmore.title" | translate }}
                </div>
                <div
                    data-cy="login-input-learn-more-info-text"
                    class="text detail"
                >
                    {{ "dlg.signin.learnmore.description" | translate }}
                </div>
            </div>
            <div
                data-cy="login-input-learn-more-window-back-button"
                class="go-back-btn caption"
                (click)="onShowLearnMore()"
            >
                {{ "dlg.signin.cancel" | translate }}
            </div>
        </div>
    </ng-template>
</div>

<app-pop-up-notification
    #signInConfirm
    [message]="'dlg.signin.successful'"
    [closeButton]="'dlg.signin.close'"
></app-pop-up-notification>
